<div class="formControl">
    <label 
        [for]="formattedLabel"
        class="formLabel"
        [ngClass]="{
            'required': isReq,
            'dontShow': noLabel,
            }"
        >
        {{labelText}}
    </label>
    <button class="toggleCont" (click)="toggleDropdown.emit()">
        <span *ngIf="localSelectedItems.length === 0">{{placeholder}}</span>
        <span *ngIf="localSelectedItems.length" class="optionSelected" title="{{localSelectedItems.join(', ')}}">{{ localSelectedItems.join(', ')}}</span>
        <span *ngIf="localSelectedItems.length" class="clrBtn" (click)="clearSelection()">Clear</span>
        <img src="/assets/images/chevron-south.svg" alt="chevron-south">
    </button>
    <div class="optionsCont" *ngIf="isDropdownOpen">
        <input
            type="text"
            [(ngModel)]="searchTerm"
            placeholder="Search..."
            class="searchField"
            *ngIf="isSearchable"
        />
        <div *ngIf="filteredOptions.length === 0" class="noResults">
            No results found.
        </div>
        <div class="scrlGrp">
            <!-- Select All / Deselect All Checkbox -->
            <label class="option select-all-option" *ngIf="isSelectAllNeeded">
                <input type="checkbox"
                    [checked]="localSelectedItems.length === filteredOptions.length && filteredOptions.length > 0"
                    (change)="toggleSelectAll()">
                <span class="styledCheckbox"></span>
                {{ localSelectedItems.length === filteredOptions.length && filteredOptions.length > 0 ? 'Deselect All' : 'Select All' }}
            </label>
            <!-- Individual Options -->
            <label 
                class="option" 
                *ngFor="let option of filteredOptions"
                [ngClass]="{'selected': isSelected(option.name)}"
                (click)="toggleSelection(option.name); $event.stopPropagation()">
                    <input type="checkbox" 
                        id="{{option.name}}" 
                        *ngIf="isMultiSelect"
                        [checked]="isSelected(option.name)" 
                        (change)="toggleSelection(option.name)">
                    <span class="styledCheckbox" *ngIf="isMultiSelect"></span>
                    {{option.name}}
            </label>
        </div>
    </div>
</div>